<template>
    <Breadcrumbs main="Widgets" title="Testimonials" />
    <div class="container-fluid">

        <orderChart />

    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const orderChart = defineAsyncComponent(() => import("@/components/pages/testimonials/index.vue"))
</script>